import * as THREE from 'three';
import { offsetHat } from "../Fiko2dPathSihirbaz";
import { FikoDuzlem } from '../FikoDuzlem';
import { FikoGrup } from "../FikoGrup";
import { FikoObje3D } from '../FikoObje3D';
import { FikoSahne } from '../FikoSahne';
import { FikoVektor2D } from "../FikoVektor2d";
import { FikoVektor3D } from "../FikoVektor3d";
import { FikoTakimFrezeleme } from "./FikoTakimFrezeleme";
import { FikoVektorTakimYol3D } from './FikoVektorTakimYol3d';


export class FikoProfil2d extends FikoGrup {
    override type: "FikoProfil2d";

    ustNokta: FikoDuzlem;
    profilNoktalar: FikoVektor2D[] | FikoVektor3D[] = [];
    altNokta: FikoDuzlem;

    daireselSapma: number = 0.001;
    islemeYontemi: "Tek Yön" | "Zik Zak" | "Helisel" = "Tek Yön";
    yanalYontem: "İlk Dikey" | "İlk Yanal" = "İlk Yanal";
    yanalHatve: number = 1;
    yanalTekrar: number = 1;

    dikeyIslemeYontemi: "Z Hatve" | "Tekrar" | "Hatveli Tekrar" = "Z Hatve";

    hatve: number = 0.5;
    hatveTekrar: number = 1;

    koseDonusler: "Keskin" | "Dairesel" | "Yakınsal" = "Dairesel";

    takim: FikoTakimFrezeleme = new FikoTakimFrezeleme(this.sahne, 10);
    takimYonu: FikoVektor3D = new FikoVektor3D(0, 0, 1);

    ilerlemeYaklasma: number = 3000;
    ilerlemeHatveleme: number = 1000;
    ilerlemeIsleme: number = 3000;
    ilerlemeUzaklasma: number = 10000;
    sonTurlar: number = 1000;

    devir: number = 2000;

    /** YAP: Giriş Çıkışlar */


    /** */
    takimHatti2d: FikoVektor3D[] = [];
    takimYoluNoktalar: FikoVektorTakimYol3D[] = [];
    /** NOT: Takım Yolu */
    constructor(public override sahne?: FikoSahne) {
        super(sahne);
    }

    override hazirla() {

    }

    guncelle() {

    }

    ilkGirisHesapla() {
        const forPosObje = new FikoObje3D();
        forPosObje.position.set(0, 0, this.ustNokta.normal.z);
        const forTalasVektor = forPosObje.translateOnAxis(this.takimYonu.normalize(), 50).position;


        let _takimYolu = new FikoVektorTakimYol3D(this.takimYoluNoktalar[0].x, this.takimYoluNoktalar[0].y, forTalasVektor.z);
        _takimYolu.hiz = this.ilerlemeUzaklasma;
        _takimYolu.devir = this.devir;
        _takimYolu.renk = new THREE.Color("red");

        this.takimYoluNoktalar.unshift(_takimYolu);

    }

    sonCikisHesapla() {
        let toplamOlcu = this.ustNokta.normal.distanceTo(this.altNokta.normal);

        const forPosObje = new FikoObje3D();
        forPosObje.position.set(0, 0, this.ustNokta.normal.z);
        const forTalasVektor = forPosObje.translateOnAxis(this.takimYonu.normalize(), 60).position;

        let _takimYolu = new FikoVektorTakimYol3D(this.takimYoluNoktalar[this.takimYoluNoktalar.length - 1].x, this.takimYoluNoktalar[this.takimYoluNoktalar.length - 1].y, forTalasVektor.z);
        _takimYolu.hiz = this.ilerlemeUzaklasma;
        _takimYolu.devir = this.devir;
        _takimYolu.renk = new THREE.Color("darkblue");

        this.takimYoluNoktalar.push(_takimYolu);
    }

    araCikisHesapla() {
        let toplamOlcu = this.ustNokta.normal.distanceTo(this.altNokta.normal);

        const forPosObje = new FikoObje3D();
        forPosObje.position.set(0, 0, this.ustNokta.normal.z);
        const forTalasVektor = forPosObje.translateOnAxis(this.takimYonu.normalize(), 60).position;

        let _takimYolu = new FikoVektorTakimYol3D(this.takimYoluNoktalar[this.takimYoluNoktalar.length - 1].x, this.takimYoluNoktalar[this.takimYoluNoktalar.length - 1].y, this.takimYoluNoktalar[this.takimYoluNoktalar.length - 1].z + 5);
        _takimYolu.hiz = this.ilerlemeUzaklasma;
        _takimYolu.devir = this.devir;
        _takimYolu.renk = new THREE.Color("darkblue");

        this.takimYoluNoktalar.push(_takimYolu);
    }

    ilkTurHesapla() {
        this.takimHatti2d = [];
        this.yanalTekrar = this.yanalTekrar || 1;
        /** NOT:  Takım Similasyon Hattının İlk Turu Hesaplanıyor */
        if (this.yanalTekrar == 1) {
            // NOT:  Yanal Tekrar 1 İse Takım Hattı Oluşturuluyor
            let anaTur = new THREE.Shape(offsetHat(this.profilNoktalar, (this.takim.cap / 2), this.koseDonusler, this.daireselSapma));
            anaTur.closePath()
            this.takimHatti2d = anaTur.getPoints().map(val => new FikoVektorTakimYol3D(val.x, val.y, 0))
        } else {
            // NOT:  Yanal Tekrar 1den Fazla İse

            if (this.yanalYontem == "İlk Yanal") {
                /** NOT:  İlk Yanal İşlenecek İse Takım Hattı Oluşturuluyor*/
                let anaTur = offsetHat(this.profilNoktalar, (this.takim.cap / 2), this.koseDonusler, this.daireselSapma);
                for (let tekrarNo = this.yanalTekrar - 1; tekrarNo >= 0; tekrarNo--) {
                    if (tekrarNo != 0) {
                        let turShape = new THREE.Shape(offsetHat(anaTur, this.yanalHatve * tekrarNo, this.koseDonusler, this.daireselSapma));
                        turShape.closePath();
                        this.takimHatti2d = this.takimHatti2d.concat(turShape.getPoints().map(val => new FikoVektorTakimYol3D(val.x, val.y, 0)));
                    } else {
                        let turShape = new THREE.Shape(anaTur);
                        turShape.closePath();
                        this.takimHatti2d = this.takimHatti2d.concat(turShape.getPoints().map(val => new FikoVektorTakimYol3D(val.x, val.y, 0)));
                    }
                }
                this.takimHatti2d.push(this.takimHatti2d[0])
            }
        }
    }


    /**
     * Hatveli takım yolunu hesapla
     *
     * DÜZELTMELER:
     * 1. İlk giriş hareketi döngüden ÖNCE yapılmalı
     * 2. Hız parametresi: İşleme için ilerlemeIsleme kullanılmalı (ilerlemeUzaklasma DEĞİL)
     * 3. Ara çıkış sadece gerektiğinde yapılmalı
     * 4. Z=0'dan başlama (i=0 durumu) düzeltildi
     */
    hatveliYoluHesapla() {
        this.ilkTurHesapla();

        if (this.takimHatti2d.length === 0) {
            console.warn('[FikoProfil2d] Takım hattı boş, hesaplama yapılamıyor');
            return;
        }

        // Z Tekrarlamaları
        const toplamOlcu = this.ustNokta.normal.distanceTo(this.altNokta.normal);
        const tekrar = Math.floor(toplamOlcu / this.hatve);

        // 1. İLK GİRİŞ HAREKETİ - Döngüden ÖNCE yapılmalı
        this.ilkGirisHesapla();

        for (let i = 0; i <= tekrar; i++) {
            const forPosObje = new FikoObje3D();
            forPosObje.position.set(0, 0, this.ustNokta.normal.z);

            // Z derinliği: i=0 için üst yüzey, i>0 için hatve kadar derin
            const zDerinlik = i * this.hatve;
            const forTalasVektor = forPosObje.translateOnAxis(this.takimYonu.normalize(), -zDerinlik).position;

            // İşleme noktaları (DÜZELTME: ilerlemeIsleme kullanılmalı)
            this.takimYoluNoktalar = this.takimYoluNoktalar.concat(this.takimHatti2d.map((val: FikoVektor3D) => {
                const _takimYolu = new FikoVektorTakimYol3D(val.x, val.y, forTalasVektor.z);
                _takimYolu.hiz = this.ilerlemeIsleme;  // DÜZELTME: İşleme hızı
                _takimYolu.devir = this.devir;
                _takimYolu.renk = new THREE.Color("chartreuse");
                return _takimYolu;
            }));

            // Ara çıkış - sadece son seviye değilse
            if (i < tekrar) {
                this.araCikisHesapla();
            }
        }

        // Son tur (tam derinlikte)
        const forPosObjeSon = new FikoObje3D();
        forPosObjeSon.position.set(0, 0, this.ustNokta.normal.z);
        const forTalasVektorSon = forPosObjeSon.translateOnAxis(this.takimYonu.normalize(), -toplamOlcu).position;

        this.takimYoluNoktalar = this.takimYoluNoktalar.concat(this.takimHatti2d.map((val: FikoVektor3D) => {
            const _takimYolu = new FikoVektorTakimYol3D(val.x, val.y, forTalasVektorSon.z);
            _takimYolu.hiz = this.sonTurlar || this.ilerlemeIsleme;  // Son tur hızı
            _takimYolu.devir = this.devir;
            _takimYolu.renk = new THREE.Color("magenta");  // Son tur farklı renk
            return _takimYolu;
        }));

        // Son çıkış hareketi
        this.sonCikisHesapla();
    }

    hesapla() {
        this.takimYoluNoktalar = [];

        this.hatveliYoluHesapla()


    }

}